import styled from "styled-components";

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  && {
    margin-bottom: 0;
  }

  button {
    text-transform: capitalize;
  }
`;
